<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <!--table-->
        <div>
          <button type="button" id="BtnPopup" (click)="showWeightageRolewise()" style="display:none">Search</button>
          <table #dataTable class="display" style="width:100%"></table>
        </div>

        <div id="btnPopupartDetails" class="modal" style="position: fixed !important;display:none">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="text-align:center">
                <h4 class="modal-title"> {{title}} </h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <!--Loader gif-->
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
              </div>

              <div class="modal-body" style="overflow-x:auto !important;">
                <div class="card">
                  <div class="card-body">

                    <div class="form-group">
                      <h5>weightage Performance {{username}}</h5>
                      <br />
                      <div class="row form-group">
                        <div class="col-sm-4">
                          <label>Role<em>*</em></label>
                          <select id="ddlRoleType" class="form-control">
                            <option *ngFor="let item of RoleList" [value]="item.RoleID">{{ item.RoleName }}</option>
                          </select>
                        </div>

                        <div class="col-sm-4">
                          <label>Non Production</label>
                          <input id="Txt_NonProduction" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" />
                        </div>

                        <div class="col-sm-4">
                          <label>Productivity Achieved<em>*</em></label>
                          <input id="Txt_ProductivityAchieved" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" />
                        </div>

                        <p class="col-sm-12 fw-semibold pt-2">
                          <strong class="text-warning">Note:</strong> Occupancy + Punctuality + Attendance must equal <strong>100</strong>.
                        </p>

                        <div class="col-sm-4">
                          <label>Occupancy<em>*</em></label>
                          <input id="Txt_Occupancy" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_Occupancy')" />
                        </div>

                        <div class="col-sm-4">
                          <label>Punctuality<em>*</em></label>
                          <input id="Txt_Punctuality" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_Punctuality')" />
                        </div>

                        <div class="col-sm-4">
                          <label>Attendance<em>*</em></label>
                          <input id="Txt_Attendance" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_Attendance')" />
                        </div>

                        <!--<div class="col-sm-4">
                          <label>LD Training<em>*</em></label>
                          <input id="Txt_LD_Training" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_LD_Training')" />
                        </div>

                        <div class="col-sm-4">
                          <label>APQC Skills<em>*</em></label>
                          <input id="Txt_APQC_Skills" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_APQC_Skills')" />
                        </div>

                        <div class="col-sm-4">
                          <label>Deliver RCA Skills<em>*</em></label>
                          <input id="Txt_DeliverRCA_Skills" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_DeliverRCA_Skills')" />
                        </div>-->

                        <div class="col-sm-4">
                          <label>Total Sum</label>
                          <input id="Txt_TotalSum" type="number" class="form-control" disabled />
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <h5>Range Performance</h5>
                      <br />
                      <div class="row form-group">

                        <!-- Poor Range -->
                        <div class="col-sm-3">
                          <label for="Txt_PoorRange">Poor Range <em>*</em></label>
                          <input id="Txt_PoorRange" type="number" class="form-control" min="0" max="100"
                                 (input)="updateRanges()" />
                        </div>

                        <!-- Moderate Range -->
                        <div class="col-sm-3">
                          <label>Moderate Range <em>*</em></label>
                          <div class="d-flex">
                            <input id="Txt_ModerateStart" type="number" class="form-control" readonly />
                            <span class="mx-1"> - </span>
                            <input id="Txt_ModerateEnd" type="number" class="form-control"
                                   (input)="updateRanges()" />
                          </div>
                        </div>

                        <!-- Good Range -->
                        <div class="col-sm-3">
                          <label>Good Range</label>
                          <div class="d-flex">
                            <input id="Txt_GoodStart" type="number" class="form-control" readonly />
                            <span class="mx-1"> - </span>
                            <input id="Txt_GoodEnd" type="number" class="form-control"
                                   (input)="updateRanges()"  readonly/>
                          </div>
                        </div>

                        <!-- Excellent Range -->
                        <div class="col-sm-3">
                          <label for="Txt_ExcellentRange">Excellent Range <em>*</em></label>
                          <input id="Txt_ExcellentRange" type="number" class="form-control" min="0" max="100"
                                 (input)="updateRanges()" />
                        </div>
                      </div>
                    </div>



                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                  <button type="submit" (click)="UpdateWeightageRolewise()" class="btn btn-outline-success waves-effect waves-light">{{popupButtonText}}</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
